









































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

import { formatCurrency } from "@/utility/Formatter";
import { CurrencyBalance } from "@/model/data/workload/CurrencyBalance";

export default Vue.extend({
    props: {
        loading: Boolean,
        transactionTotals: Array,
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        chart() {
            var labels = [];
            var cashInSerie = {
                name: this.$t("enum.transaction_flow.cash_in"),
                data: [],
            };
            var cashOutSerie = {
                name: this.$t("enum.transaction_flow.cash_out"),
                data: [],
            };
            (this.transactionTotals as CurrencyBalance[]).forEach((k) => {
                labels.push(k.currency);
                cashInSerie.data.push(k.cashIn);
                cashOutSerie.data.push(-1 * k.cashOut);
                // balanceSerie.data.push(this.transaction_total.value[k].balance);
            });
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    labels,
                    chart: {
                        stacked: true,
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    xaxis: {
                        labels: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        formatter: function (val, opts) {
                            return formatCurrency(labels[opts.dataPointIndex], val);
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                },
                series: [cashInSerie, cashOutSerie /*, balanceSerie*/],
            };
        },
    },
    methods: { formatCurrency },
});
